// Slot accounting for images attached to the chat prompt bar. Kept separate
// from ActionBar so the cap logic is unit-testable without rendering it.
//
// This number must equal MAX_REFERENCE_SLOTS in
// services/py/shared/utils/reference_images.py. The customer gives photos through
// two surfaces: this message box and the server's reference card. A customer
// reads them as one limit. When the two numbers differ, the smaller one binds,
// and the larger surface offers slots that no single gesture can fill. That is
// the ADO-2004 defect. A cross-language test guards the pair, because no
// compiler can see both files.
export const MAX_PROMPT_IMAGES = 10;

export const PROMPT_IMAGE_CAP_MESSAGE = `You can attach up to ${MAX_PROMPT_IMAGES} images per message`;

/**
 * Splits an incoming batch of files into the ones that fit in the remaining
 * attachment slots and a count of those that don't. Attachments in any status
 * (uploading, errored) occupy a slot until the user removes them.
 */
export function takeFilesForRemainingSlots(
	files: File[],
	attachedCount: number,
): { accepted: File[]; overflow: number } {
	return splitFilesToCapacity(files, MAX_PROMPT_IMAGES - attachedCount);
}

/**
 * Takes the first `capacity` files and counts the rest as overflow. A negative
 * capacity means there is no room at all, so nothing is accepted. The
 * reference-image card shares this rule: it has its own, server-driven number
 * of slots, so it passes its own capacity rather than the prompt-bar cap.
 */
export function splitFilesToCapacity(
	files: File[],
	capacity: number,
): { accepted: File[]; overflow: number } {
	const accepted = files.slice(0, Math.max(0, capacity));
	return { accepted, overflow: files.length - accepted.length };
}
